/**
 * Renders one or more JSON-LD structured-data blocks as
 * <script type="application/ld+json"> elements.
 *
 * These are rendered as ordinary React elements (not via Helmet) because
 * structured data is valid anywhere in the document and search engines read it
 * from the body as well as the head. `<` is escaped so a stray "</script>" in
 * the data can never break out of the tag.
 */
export default function JsonLd({ data }: { data: object | object[] }) {
  const blocks = Array.isArray(data) ? data : [data];

  return (
    <>
      {blocks.map((block, i) => (
        <script
          key={i}
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html: JSON.stringify(block).replace(/</g, '\\u003c'),
          }}
        />
      ))}
    </>
  );
}
